module.exports = __webpack_public_path__ + "img/Google.67a37d54.png";